import { useParams, Navigate, Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { trustPages } from "@/data/trust";

function Cta({ cta }) {
  if (!cta) return null;
  const isExternal = /^(https?:|mailto:)/.test(cta.to);
  const cls =
    "mt-6 inline-flex items-center gap-2 rounded-full bg-paper text-black text-sm font-medium px-5 py-3 hover:bg-white transition-colors";
  if (isExternal) {
    return (
      <a href={cta.to} className={cls} data-testid="trust-cta">
        {cta.label}
        <Icons.ArrowUpRight size={15} aria-hidden="true" />
      </a>
    );
  }
  return (
    <Link to={cta.to} className={cls} data-testid="trust-cta">
      {cta.label}
      <Icons.ArrowUpRight size={15} aria-hidden="true" />
    </Link>
  );
}

export default function TrustDetail() {
  const { slug } = useParams();
  const t = trustPages.find((x) => x.slug === slug);
  if (!t) return <Navigate to="/trust" replace />;

  return (
    <PageLayout
      seoTitle={t.seoTitle}
      seoDescription={t.seoDescription}
      path={`/trust/${t.slug}`}
      back={{ to: "/trust", label: "Trust Center" }}
      eyebrow="Trust Center"
      title={t.title}
      subtitle={t.intro}
      testid={`trust-${t.slug}`}
    >
      <div className="grid gap-px bg-white/10 border border-white/10 sm:grid-cols-2 rounded-2xl overflow-hidden">
        {t.sections.map((sec, i) => (
          <section key={i} className="bg-surface p-7">
            <h2 className="font-display text-lg tracking-tight text-paper mb-2">{sec.heading}</h2>
            <p className="text-sm text-fog leading-relaxed">{sec.body}</p>
          </section>
        ))}
      </div>

      {t.note && <p className="mt-4 text-xs text-fog/70 italic">{t.note}</p>}

      {t.cta && (
        <div className="mt-10">
          <Cta cta={t.cta} />
        </div>
      )}
    </PageLayout>
  );
}
